<template>
  <div id="general-setting" class="grid">
    <div class="grid-title">
      <h4>{{ $t("GENERAL_SETTING") }}</h4>
      <v-btn color="primary" class="pl-10 pr-10" @click="save">{{ $t("SAVE") }}</v-btn>
    </div>
    <div class="grid-body p-3 pb-0 border-top-unset">
      <v-form ref="formInfo" lazy-validation >
      <div class="email-setting">
        <label class="label-title">{{ $t("EMAIL_CONFIGURATION") }}</label> <br>
        <div class="row-process mt-3">
          <div>
            <label class="label-input">{{ $t("HOTEL_EMAIL") }} *</label>
             <v-text-field v-model="data.email" outlined dense :rules="ruleEmail"></v-text-field>
          </div>
          <div>
            <label class="label-input">{{ $t("EMAIL_RECEIVE_BOOKING_ALERT_CC") }} *</label>
            <v-text-field v-model="data.notifyToEmail" outlined dense :rules="ruleEmail"></v-text-field>
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">
              {{
              $t("EMAIL_CO_RECEIVE_BOOKING_ALERT_CC")
              }}
            </label>
            <v-text-field v-model="data.notifyCCEmail1" outlined dense></v-text-field>
          </div>
          <div>
            <label class="label-input">
              {{
              $t("EMAIL_RECEIVE_BOOKING_ALERT_BCC")
              }}
            </label>
            <v-text-field v-model="data.notifyBCCEmail" outlined dense></v-text-field>
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">
              {{
              $t("EMAIL_ACCESSTOKEN")
              }}
            </label>
            <v-text-field v-model="data.accessTokenEmail" outlined dense :rules="ruleEmailNotRequied"></v-text-field>
          </div>
          <div></div>
        </div>
        <div class="row-process mb-0 align-items-center">
          <div class="d-flex align-items-center">
            <v-checkbox class="mt-0 pt-0"
              v-model="data.autoCancel"
              :label="$t('AUTO_CANCEL')"
            ></v-checkbox>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <i class="icon-info fs-18 ml-2 text-primary" v-bind="attrs"
                v-on="on"></i>
              </template>
              <div class="fs-13" style="max-width: 400px" v-html="$t('TOOLTIP_AUTO_CANCEL')"></div>
            </v-tooltip>
          </div>
          <div class="d-flex align-items-center">
            <v-checkbox class="mt-0 pt-0"
              v-model="data.autoCancelledByPaymentFail"
              :label="$t('AUTO_CANCEL_PAYMENT_FAIL')"
            ></v-checkbox>
            <v-text-field @keypress="preventNonPositiveIntegers"
            @paste="preventPasteNonPositiveIntegers" style="max-width: 100px !important;" class="mx-1 text-right" :disabled="!data.autoCancelledByPaymentFail" v-model="data.timeToCancelledByPaymentFail" outlined dense min="0" type="number"></v-text-field> {{ $t('MINUTES') }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <i class="icon-info fs-18 ml-2 text-primary" v-bind="attrs"
                v-on="on"></i>
              </template>
              <div class="fs-13" style="max-width: 400px" v-html="$t('TOOLTIP_AUTO_CANCEL_PAYMENT_FAIL')"></div>
            </v-tooltip>
          </div>
        </div>
      </div>

      <div class="email-setting">
        <label class="label-title mb-3">
          {{
          $t("DISPLAY_LANGUAGE_AND_WEEKEND")
          }}
        </label>
        <div class="row-process mt-3">
          <div>
            <label class="d-flex label-input">{{ $t("DISPLAY_LANGUAGE") }} *
              <v-tooltip top nudge-right="200">
                <template v-slot:activator="{ on, attrs }">
                  <i class="icon-info fs-18 ml-2 text-primary" v-bind="attrs"
                  v-on="on"></i>
                </template>
                <div class="fs-13" style="max-width: 400px" v-html="$t('TOOLTIP_TOGGLE_LANGUAGE')"></div>
              </v-tooltip>
            </label>
            <v-layout wrap >
              <b-dropdown id="dropdown-lang" toggle="manual" variant="outline-default" :text="listNameLangs.join(', ')" class="custom-dropdown" :toggle-class="{'mandatory-errors': !!error.selectedLanguages}" auto-close="outside">
                <template #default>
                  <div 
                    v-for="lang in listLangs" 
                    :key="lang.languageCode" 
                    class="dropdown-item w-100"
                    @click="toggleLanguage(lang.languageCode, $event)"
                  >
                    <label class="d-flex align-items-center w-100">
                      <b-form-checkbox 
                        v-model="selectedLanguages" 
                        :value="lang.languageCode"
                        class="mr-1"
                        :disabled="data.language.split(',').includes(lang.languageCode) && mandatoryLanguage.includes(lang.languageCode)"
                      />
                      <img :src="'https://static.oneinventory.com'+lang.flagUrl" :alt="lang.name" class="flag-icon mr-2" />
                      {{ lang.name }}
                    </label>
                  </div>
                </template>
              </b-dropdown>
              <div class="text-danger fs-12 font-weight-500" v-if="!!error.selectedLanguages">
                {{ error.selectedLanguages.message }}
              </div>
            </v-layout>
          </div>
          <div>
            <label class="label-input">{{ $t("DEFAULT_LANGUAGE") }} *</label>
            <v-layout wrap >
              <v-radio-group
                v-model="data.languageInUse"
                row
                :rules="[isRequired]"
                class="languageInUse-errors"
              >
                <!-- <v-radio v-for="lang in listLangs"
                  :key="lang.languageCode"
                  :label="lang.name"
                  :value="lang.languageCode"
                ></v-radio> -->
                <v-radio
                  :label="$t('VIETNAMESE')"
                  value="vi"
                ></v-radio>
                <v-radio
                  :label="$t('ENGLISH')"
                  value="en"
                ></v-radio>
              </v-radio-group>
            </v-layout>
          </div>
        </div>
       
        <label class="label-input mt-3 mb-2">{{ $t("WEEKEND") }} *</label>
        <v-layout wrap required>
          <v-chip-group v-model="weekend" column multiple active-class="primary">
            <v-chip v-for="date in daysOfWeek" :value="date.date" class="chip-date">
              {{date.text}}
            </v-chip>
          </v-chip-group>
        </v-layout>
        <div class="v-messages error--text pt-2" v-if="weekend.length === 0">{{ $t("CBALERT_LB_AVAISEARCH") }}</div>
      </div>

      <div class="email-setting">
        <label class="label-title mb-3">
          {{
          $t("CURRENCY_AND_TAXES_FEES")
          }}
        </label> <br>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("CURRENCY_USED_IN_SYSTEM") }} *</label>
            <v-autocomplete
              :items="currency"
              v-model="data.usedCurrency"
              item-text="name"
              item-value="code"
              outlined dense
            ></v-autocomplete>
          </div>
          <div>
            <label class="label-input">{{ $t("VAT_RATE_IS_APPLIES") }} *</label>
            <v-text-field v-model="data.dataAddedTaxPercent"
             outlined dense :rules="ruleVat" type="number" max="100" min="0"></v-text-field>
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("SERVICE_TAX_RATE_APPLIES") }} *</label>
            <v-text-field v-model="data.serviceTaxPercent"
             outlined dense :rules="ruleVat" type="number" max="100" min="0"></v-text-field>
          </div>
          <div>
            <v-checkbox
              :label="$t('PRICES_INCLUDE_TAXES_FEES')"
              color="indigo darken-3"
              v-model="data.includeTaxesInPrice"
            ></v-checkbox>
          </div>
        </div>
        <small class="text-danger" v-html="$t('GOOGLE_NOTE')"></small>
      </div>

      <div class="email-setting">
        <label class="label-title mb-3">
          {{
          $t("REGULATIONS_ON_CHILD_AGE_AND_ACCOMPANING_FEE")
          }}
        </label> <br>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("YOUTH_IS_FREE_OF_CHARGE") }} *</label>
             <v-autocomplete
              :items="baged"
              v-model="data.baged"
              outlined dense
              required  :rules="[v => !!v || '']"
            ></v-autocomplete>
          </div>
          <div>
            <label class="label-input">{{ $t("AGE_CHILD_EXTRA_CHARGE") }} *</label>
            <v-autocomplete
              :items="caged"
              v-model="data.caged"
              outlined dense
              required  :rules="[v => !!v  || '']"
            ></v-autocomplete>
          </div>
        </div>
        <v-tabs v-model="tabChildPolicy" class="pl-0">
          <v-tab v-for="name in listNameLangs" :key="name">{{ name }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabChildPolicy">
          <v-tab-item v-for="code in listCodeLangs" :key="code">
            <v-row>
              <v-col sm="12" class="pb-0">
                <label>{{ $t("CHILD_AND_BED") }}</label>
                <v-textarea v-model="data.i18nPolicies.find(x => x.lang == code).childPolicy" outlined
                  v-if="data.i18nPolicies && data.i18nPolicies.length > 0"
                  :rows="6"
                  counter="3000"
                  maxlength="3000"
                  class="input-counter"
                  :rules="ruleDescNotRequired"
                  dense></v-textarea>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <div class="email-setting no-border">
        <label class="label-title mb-3">{{ $t("OTHER_INFOMATION") }}</label> <br>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("CHECKIN_TIME") }} *</label>
            <v-autocomplete
              :items="selectTime"
              v-model="data.checkInTime"
              outlined dense
            ></v-autocomplete>
          </div>
          <div>
            <label class="label-input">{{ $t("CHECKOUT_TIME") }} *</label>
             <v-autocomplete
              :items="selectTime"
              v-model="data.checkOutTime"
              outlined dense
            ></v-autocomplete>
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("YEAR_BUILT") }}</label>
            <v-text-field v-model="data.yearOfBuild" outlined dense  type="number" min="0"></v-text-field>
          </div>
          <div>
            <label class="label-input">
              {{
              $t("TOTAL_NUMBER_OF_FLOORS")
              }}
            </label>
            <v-text-field v-model="data.numberOfFloors" outlined dense  type="number" min="0"></v-text-field>
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("TOTAL_ROOM") }}</label>
            <v-text-field v-model="data.numberOfRooms" outlined dense  type="number" min="0" disabled></v-text-field>
          </div>
          <div>
            <label class="label-input">{{ $t("DISTANCE_TO_AIRPORT") }} (km)</label>
            <v-text-field v-model="data.distanceToAirport" outlined dense type="number" min="0"></v-text-field>
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">
              {{
              $t("DISTANCE_TO_CITY_CENTER")
              }} (km)
            </label>
            <v-text-field v-model="data.distanceToCenter" outlined dense type="number" min="0"></v-text-field>
          </div>
          <div>
            <label class="label-input">{{ $t("TIME_TO_AIRPORT") }}</label>
            <v-text-field v-model="data.minutesToAirport" outlined dense type="number" min="0"></v-text-field>
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("VOLTAGE_USED") }}</label>
             <v-autocomplete
              :items="electronicVoltage"
              v-model="data.electronicVoltage"
              outlined dense
               item-text="value"
              item-value="value"
            ></v-autocomplete>
          </div>
          <div>
            <label class="label-input">{{ $t("ROOM_SERVICE") }}</label>
             <v-autocomplete
              :items="roomServices"
              v-model="data.roomServices"
              outlined dense
              item-text="text"
              item-value="value"
            ></v-autocomplete>
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("TYPE_APPLY_PROMOTION") }}</label>
             <v-autocomplete
              :items="typeApplyPromotion"
              v-model="data.promotionConnection"
              outlined dense
              item-text="text"
              item-value="value"
            ></v-autocomplete>
          </div>
          <div>
            <label class="label-input">{{ $t("TYPE_PROMOTION") }}</label>
             <v-autocomplete
              :items="typePromotion"
              v-model="data.typePromotion"
              outlined dense
              item-text="text"
              item-value="value"
            ></v-autocomplete>
          </div>
        </div>

        <v-tabs v-model="tabHotelPolicy" class="pl-0">
          <v-tab v-for="name in listNameLangs" :key="name">{{ name }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabHotelPolicy">
          <v-tab-item v-for="code in listCodeLangs" :key="code">
            <v-row>
              <v-col sm="12" class="pb-0">
                <label class="label-input">{{ $t("HOTEL_RULES") }}</label>
                <v-textarea v-model="data.i18nPolicies.find(x => x.lang == code).hotelPolicy" outlined
                  v-if="data.i18nPolicies && data.i18nPolicies.length > 0"
                  :rows="6"
                  counter="3000"
                  maxlength="3000"
                  class="input-counter"
                  :rules="ruleDescNotRequired"
                  dense></v-textarea>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </div>
      </v-form>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  h4.sub-header {
    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
    color: #444343;
    padding-top: 15px;
  }
</style>
<script>
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import { VueEditor } from "vue2-editor";
import {
  _validateFormI18n,
  _alert,
  _resetErrorState
} from "@/_helpers/function.js";
import {
  REGEX_PHONE,
  REGEX_ENTERPRISE_CODE,
  REGEX_NUMBER,
  REGEX_DISTANCE
} from "@/_helpers/constant.js";
import {
  DAYS_OF_WEEK,
  GE_ROOM_SERVICES,
  CURRENCY,
  GE_ERROR,
  ELECT_VOLT
} from "@/_helpers/config.js";
import { service } from "@/_services/HotelSetting/general-setting.service.js";
import Textarea from "@/components/Utils/Textarea.vue";
import { chainService } from "@/_services/ChainManage/chain.service.js";
export default {
  components: {
    "input-text": Input,
    "select-text": Select,
    VueEditor,
    "input-textarea": Textarea
  },
  data() {
    return {
      systemLang: this.$i18n.locale,
      data: {},
      error: Object.assign({}, GE_ERROR),
      // Config
      tabChildPolicy: null,
      tabHotelPolicy: null,
      lang: null,
      weekend: [],
      defaultWeekend: [],
      displayLang: [],
      selectTime: [],
      language: [],
      baged: Array.from(new Array(17), (val, i) => i + 1),
      caged: Array.from(new Array(17), (val, i) => i + 1),
      electronicVoltage: ELECT_VOLT,
      daysOfWeek: DAYS_OF_WEEK,
      roomServices: GE_ROOM_SERVICES,
      currency: [],
      typePromotion: [],
      typeApplyPromotion: [
        { value: 0, text: 'ezCrs' },
        { value: 1, text: 'ezPromotion' },
      ],
      listLangs: [],
      selectedLanguages: [],
      listNameLangs: [],
      listCodeLangs: [],
      languages: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.name) : [],
      codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : [],
      mandatoryLanguage: ['vi', 'en'], // List of mandatory languages
    };
  },
  created() {
    this.roomServices = GE_ROOM_SERVICES;
    this.initialize();
  },
  mounted() {
    this.getLangs();
  },
  computed: {
    REGEX_ENTERPRISE_CODE() {
      return REGEX_ENTERPRISE_CODE;
    },
    REGEX_PHONE() {
      return REGEX_PHONE;
    },
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    REGEX_DISTANCE() {
      return REGEX_DISTANCE;
    },
    GE_ERROR() {
      return GE_ERROR;
    },
  },
  watch: {
    lang(value) {
      this.editorData = this.data.i18ns.find(x => x.lang == value).name;
    },
    weekend(value) {
      let tmp = [0,0,0,0,0,0,0];
      value.forEach( function( element ){
        if ( element === 'MON' ) {
          tmp[0] = 1;
        }

        if ( element === 'TUE' ) {
          tmp[1] = 1;
        }

        if ( element === 'WED' ) {
          tmp[2] = 1;
        }

        if ( element === 'THU' ) {
          tmp[3] = 1;
        }

        if ( element === 'FRI' ) {
          tmp[4] = 1;
        }

        if ( element === 'SAT' ) {
          tmp[5] = 1;
        }

        if ( element === 'SUN' ) {
          tmp[6] = 1;
        }
      });

      this.data.weekend = parseInt( tmp.join(''), 2);
    },
    displayLang(value) {
      this.data.language = value.join();
    }
  },
  methods: {
    isRequired(value) {
      return !!value || this.$t('_REGISTER.REQUIRED_FIELD');
    },
    toggleLanguage(code, event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.data.language.split(',').includes(code) && this.mandatoryLanguage.includes(code)) {
        return;
      }
      const index = this.selectedLanguages.indexOf(code);
      if (index > -1) {
        this.selectedLanguages.splice(index, 1);
        const policyIndex = this.data.i18nPolicies.findIndex(p => p.lang === code);
        if (policyIndex > -1) {
          this.data.i18nPolicies.splice(policyIndex, 1);
        }
      } else {
        this.selectedLanguages.push(code);
        const policy = {
          lang: code,
          childPolicy: null,
          hotelPolicy: ""
        };
        this.data.i18nPolicies.push(policy);
      }
      const isValid = this.mandatoryLanguage.every(lang => this.selectedLanguages.includes(lang));
      if(isValid && !!this.error.selectedLanguages) {
        delete this.error.selectedLanguages;
      }
      this.updateLang();
    },
    preventNonPositiveIntegers(event) {
      // Allow only digits (0-9)
      if (event.keyCode < 48 || event.keyCode > 57) {
        event.preventDefault();
      }
    },
    preventPasteNonPositiveIntegers(event) {
      const paste = (event.clipboardData || window.clipboardData).getData('text');
      if (!/^[1-9]\d*$/.test(paste)) {
        event.preventDefault();
      }
    },
    async initialize() {
      this.currency = JSON.parse(localStorage.getItem("currencys"));
      _resetErrorState(this.error);
      let x = 30; //minutes interval
      let tt = 0;

      for (let i = 0; tt < 24 * 60; i++) {
        let hh = Math.floor(tt / 60);
        let mm = tt % 60;
        this.selectTime[i] =
          ("0" + (hh % 24)).slice(-2) + ":" + ("0" + mm).slice(-2);
        tt = tt + x;
      }
      await service.get().then(res => {
        this.data = res.data;    
        // Default value if null
        if (this.data.typePromotion === 0) {
          this.typePromotion = [
            { value: 0, text: this.$t("SUM_PROMOTION") },
            { value: 1, text: this.$t("PRIORITY_PROMOTION") },
            { value: 2, text: this.$t("BEST_PROMOTION") }
          ];
        } else {
          this.typePromotion = [
            { value: 1, text: this.$t("PRIORITY_PROMOTION") },
            { value: 2, text: this.$t("BEST_PROMOTION") }
          ];
        }
        if (
          !this.data.includeTaxesInPrice &&
          this.data.includeTaxesInPrice !== false
        ) {
          this.data.includeTaxesInPrice = true;
        }
        this.data.language = res.data.language || res.data.languageInUse;
        this.selectedLanguages = res.data.language.split(',') || [res.data.languageInUse];
        this.lang = res.data.languageInUse;
        this.data.weekend = res.data.weekend || "SAT,SUN";
        this.data.checkInTime = this.data.checkInTime || "14:00";
        this.data.checkOutTime = this.data.checkOutTime || "12:00";
        // Display data
        this.displayLang = res.data.language.split(",");

        this.defaultWeekend = this.convertFromBinaryToListSelection( res.data.weekend );
        var tmp = [];
        this.defaultWeekend.forEach( function( element, index ){
          if ( element == 1 ) {
            if ( index == 0 ) {
              tmp.push('MON');
            }
            if ( index == 1 ) {
              tmp.push('TUE');
            }
            if ( index == 2 ) {
              tmp.push('WED');
            }
            if ( index == 3 ) {
              tmp.push('THU');
            }
            if ( index == 4 ) {
              tmp.push('FRI');
            }
            if ( index == 5 ) {
              tmp.push('SAT');
            }
            if ( index == 6 ) {
              tmp.push('SUN');
            }
          }
        });
        this.weekend = tmp;

        if (!this.data.i18nPolicies || (this.data.i18nPolicies && !this.data.i18nPolicies.length)) {
          this.data.i18nPolicies = [];
          this.selectedLanguages.forEach((codeLang) => {
            if (codeLang) {
              const policy = {
                lang: codeLang,
                childPolicy: null,
                hotelPolicy: ""
              };
              this.data.i18nPolicies.push(policy);
            }
          })
        }
      });
      await chainService.getListLangs().then(res => {
        this.languages = res.data;
        if(this.languages.length > 0) localStorage.setItem('listLangs', JSON.stringify(this.languages));
      });
      this.getSelectedLanguageNames();
    },
    convertFromBinaryToListSelection(number) {
      let output = parseInt(number, 10).toString(2);
      while (output.length < 7) {
      output = "0" + output;
      }
      return output.split('');
    },
    async getLangs() {
      await service.getLangs().then(res => {
        this.listLangs = res.data;
      });
    },
    updateLang() {
      this.getSelectedLanguageNames();
    },
    getSelectedLanguageNames() {
      this.listNameLangs = this.selectedLanguages.map(selectedCode => {
        const foundLang = this.listLangs.find(lang => lang.languageCode === selectedCode);
        return foundLang ? foundLang.name : null;
      }).filter(name => name);
      this.listCodeLangs = this.selectedLanguages.map(selectedCode => {
        const foundLang = this.listLangs.find(lang => lang.languageCode === selectedCode);
        return foundLang ? foundLang.languageCode : null;
      }).filter(languageCode => languageCode);
    },
    save() {
      localStorage.setItem('listLangs', JSON.stringify(this.languages));
      let { isValid, error } = _validateFormI18n(this.data, this.error);
      this.error = error;

      // Validate mandatory languages
      const isValidMandatoryLanguage = this.mandatoryLanguage.every(lang => this.selectedLanguages.includes(lang));
      if (!isValidMandatoryLanguage) {
        this.$set(this.error, 'selectedLanguages', {
          error: true,
          message: this.$t('MANDATORY_LANGUAGE_REQUIRED')
        });
        isValid = false;
      }
      if (!this.$refs.formInfo.validate()) return false;
      if (!isValid || this.weekend.length === 0) return false;
      let temp = Object.assign({}, this.data);
      temp.language = this.selectedLanguages.filter(item => item).toString();
      temp.minutesToAirport = parseFloat(temp.minutesToAirport);
      service.update(temp).then(res => {
        _alert(res, this.$t(res.data));
      });
    }
  }
};
</script>